import React from "react";
import {fromJS, Map} from "immutable";
import ActionButton from "../../../components/ActionButton";
import {useDispatch} from "react-redux";
import {cancelConsignmentDetails} from "../../../actions/ConsignmentApiActions";
import AddressInline from "../../../components/AddressInline";
import InlineTable from "../../../components/InlineTable";
import {dateWithTimeFormat, fromUTCString} from "../../../lib/DateFormatter";


const FIELDS = fromJS([
  { field: "trackingNr", title: "Tracking Nr"},
  { field: "type", title: "Activity", className: "capitalize"},
  { field: "location", title: "Location"},
  { field: "message", title: "Message"},
  { field: "occurredAtUtc", title: "Date"},
])

export default function ConsignmentDetailsFormContainer(props) {
  const {
    consignmentAndActivities,
  } = props;

  const dispatch = useDispatch();

  const consignment = consignmentAndActivities.get("consignment") || Map();
  const consignmentActivities = consignmentAndActivities.get("consignmentActivities") || Map();
  const activities = consignmentActivities.get("activities").map((activity, index) => activity.set("id", index));

  function handleCancel() {
    dispatch(cancelConsignmentDetails());
  }

  return (
    <div>
      <div>
        <h3>Recipient Address:</h3>
        <div><AddressInline address={consignment.get("recipient")} /></div>
      </div>
      <div>
        <h3>Warehouse Address:</h3>
        <div>{formatWarehouseAddress(consignment.get("sender"))}</div>
      </div>
      <div>
        <h3>Tracking Numbers:</h3>
        <div>{consignment.get("packages").map((p) => p.get("trackingNr")).join(", ")}</div>
      </div>
      <div>
        <h3>Activities (last update "{formatDateString(consignmentActivities.get("updatedAt"))}"):</h3>
        <div>
          <InlineTable
            data={activities}
            fields={FIELDS}
            dataType="activities"
          />
        </div>
      </div>
      
      <div style={{marginTop: "16px"}}></div>

      <ActionButton label="Cancel" primary={false} onClick={handleCancel} />
    </div>
  )
}

function formatDateString(dateString) {
  const date = fromUTCString(dateString);
  return date && dateWithTimeFormat(date);
}

function formatWarehouseAddress(sender) {
  return `Warehouse, ${sender.get("addressCity")}, (${sender.get("addressCountryCode")})`;
}
function formatRecipientAddress(recipient) {
  return `${recipient.get("addressAddressLine1")}, ${recipient.get("addressCity")}, (${recipient.get("addressCountryCode")})`;
}